// Cursos privados: al reservar hay que indicar el idioma (Español/Inglés) y
// si la licencia es nueva o renovación — de eso depende lo que el negocio le
// paga al instructor (pedido del cliente 2026-09-21). Solo aplica a las
// categorías marcadas como "Curso privado" en el editor de categorías o cuyo
// nombre incluya "privado" (compatibilidad con las categorías ya creadas).
export const COURSE_LANGUAGE_OPTIONS = [
  { value: 'es', label: 'Español' },
  { value: 'en', label: 'Inglés' },
];

export const LICENSE_TYPE_OPTIONS = [
  { value: 'new', label: 'Licencia nueva' },
  { value: 'renewal', label: 'Renovación' },
];

export function isPrivateCourse(category) {
  if (!category) return false;
  if (category.privateCourse === true) return true;
  const type = category.type || category.categoryType;
  if (type && type !== 'course' && type !== 'class') return false;
  return /privado/i.test(String(category.name || category.categoryName || ''));
}

export function courseLanguageLabel(value) {
  const opt = COURSE_LANGUAGE_OPTIONS.find((o) => o.value === value);
  return opt ? opt.label : '';
}

export function licenseTypeLabel(value) {
  const opt = LICENSE_TYPE_OPTIONS.find((o) => o.value === value);
  return opt ? opt.label : '';
}

// Texto corto para listas/tooltips: "Español · Renovación".
// Solo aplica a cursos privados: si la categoría no es privada devuelve ''
// aunque la reservación tenga los campos (pedido 2026-09-24: el staff los
// tocaba en cursos regulares y la hoja salía como "Privado").
export function privateCourseSummary(reservation, category = null) {
  if (!reservation) return '';
  const cat = category || { name: reservation.categoryName, type: reservation.categoryType };
  if (!isPrivateCourse(cat)) return '';
  return [courseLanguageLabel(reservation.courseLanguage), licenseTypeLabel(reservation.licenseType)]
    .filter(Boolean)
    .join(' · ');
}
